(function () {
  var Y = window.YZ || {};
  var R = Y.routes || { cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' };
  var DUO_OFF = Y.duoOff || 990, BANDE_OFF = Y.bandeOff || 2970;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TX = Y.t || {};

  function T(k, vars) {
    var s = TX[k] || k;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  }
  function money(c) {
    var f = Y.money || '{{amount_with_comma_separator}} €';
    var v = c / 100;
    var a = v.toFixed(2);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return String(Math.round(v));
      if (k.indexOf('comma') > -1) return a.replace('.', ',');
      return a;
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function json(r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }
  function post(url, data) {
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(json);
  }
  function getCart() { return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(json); }

  /* Apparition au defilement */
  var reveals = document.querySelectorAll('[data-yz-reveal]');
  if (!('IntersectionObserver' in window) || reduce) {
    reveals.forEach(function (e) { e.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (!x.isIntersecting) return;
        var t = x.target;
        t.classList.add('is-in');
        io.unobserve(t);
        setTimeout(function () { t.style.transitionDelay = '0ms'; }, 1400);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (e) { io.observe(e); });
  }

  /* Galerie produit */
  var galGoto = null;
  document.querySelectorAll('[data-yz-gal]').forEach(function (gal) {
    var main = gal.querySelector('[data-yz-main]');
    var thumbs = gal.querySelectorAll('[data-yz-i]');
    function mark(i) { thumbs.forEach(function (o, n) { if (n === i) o.setAttribute('aria-current', 'true'); else o.removeAttribute('aria-current'); }); }
    function go(i) { if (!main) return; main.scrollTo({ left: i * main.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(i); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-yz-i'), 10)); });
    });
    var tm;
    if (main) main.addEventListener('scroll', function () {
      clearTimeout(tm);
      tm = setTimeout(function () { mark(Math.round(main.scrollLeft / main.clientWidth)); }, 80);
    });
    galGoto = function (mediaId) {
      if (!main || !mediaId) return;
      var slides = main.querySelectorAll('[data-yz-media]');
      for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-yz-media') === String(mediaId)) { go(i); return; } }
    };
  });

  /* Choix du pack et des visages */
  var multi = document.querySelector('form[data-yz-multi]');
  function packN() {
    var r = multi && multi.querySelector('input[name=yz_pack]:checked');
    return r ? parseInt(r.value, 10) : 1;
  }
  function applyPack() {
    if (!multi) return;
    var n = packN();
    multi.querySelectorAll('[data-yz-slot]').forEach(function (s) {
      var on = parseInt(s.getAttribute('data-yz-slot'), 10) < n;
      s.disabled = !on;
      s.hidden = !on;
    });
  }
  if (multi) {
    var qp = (location.search.match(/[?&]pack=(\d)/) || [])[1];
    if (qp) {
      var r0 = multi.querySelector('input[name=yz_pack][value="' + qp + '"]');
      if (r0) r0.checked = true;
    }
    applyPack();
    multi.addEventListener('change', function (e) {
      if (e.target.name === 'yz_pack') applyPack();
      if (e.target.getAttribute('data-media')) { if (galGoto) galGoto(e.target.getAttribute('data-media')); }
    });
  }
  function itemsFromForm(f) {
    var counts = {}, order = [];
    f.querySelectorAll('[data-yz-slot]').forEach(function (s) {
      if (s.disabled) return;
      var c = s.querySelector('input[type=radio]:checked');
      if (!c) return;
      if (!counts[c.value]) { counts[c.value] = 0; order.push(c.value); }
      counts[c.value]++;
    });
    return order.map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
  }

  /* Panier lateral */
  var dr = document.querySelector('[data-yz-drawer]');
  var lastFocus = null;
  function openD() {
    if (!dr) return;
    lastFocus = document.activeElement;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('yz-lock');
    var x = dr.querySelector('.yz-drawer__x');
    if (x) x.focus();
  }
  function closeD() {
    if (!dr) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('yz-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCount(n) {
    document.querySelectorAll('[data-yz-count]').forEach(function (e) { e.textContent = n; });
    document.querySelectorAll('[data-yz-cart-open]').forEach(function (e) { e.setAttribute('aria-label', T('cart', { n: n })); });
  }
  function bump() {
    document.querySelectorAll('.yz-cart').forEach(function (e) { e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); });
  }
  function faceName(v) {
    var names = Y.faces || {};
    return names[v.id] || v.title;
  }
  function nextFace(c) {
    var p = Y.product;
    if (!p || !p.variants || !p.variants.length) return null;
    var inCart = {};
    c.items.forEach(function (i) { inCart[i.variant_id] = true; });
    for (var i = 0; i < p.variants.length; i++) { if (!inCart[p.variants[i].id] && p.variants[i].available !== false) return p.variants[i]; }
    return p.variants[0];
  }
  function upsell(c) {
    var p = Y.product;
    if (!p) return '';
    var q = 0;
    c.items.forEach(function (i) { if (i.product_id === p.id) q += i.quantity; });
    var f = nextFace(c);
    if (!f || q === 0 || q >= 4) return '';
    var fn = esc(faceName(f));
    if (q === 1) {
      return '<div class="yz-up"><p class="yz-up__t">' + esc(T('u1t')) + '</p><p>' + T('u1p', { face: fn, save: money(DUO_OFF) }) + '</p><button type="button" class="yz-btn" data-yz-addv="' + f.id + '" data-yz-addq="1">' + esc(T('u1b')) + '</button></div>';
    }
    var miss = 4 - q;
    return '<div class="yz-up"><p class="yz-up__t">' + esc(T('u2t')) + '</p><p>' + T(miss > 1 ? 'u2pn' : 'u2p1', { n: miss, save: money(BANDE_OFF) }) + '</p><button type="button" class="yz-btn" data-yz-addv="' + f.id + '" data-yz-addq="' + miss + '">' + T('u2b', { n: miss, face: fn }) + '</button></div>';
  }
  function line(i) {
    var img = i.image ? '<img src="' + esc(i.image) + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="76" height="76" loading="lazy">' : '<span></span>';
    var v = i.variant_title ? '<div class="yz-line__v">' + esc(i.variant_title) + '</div>' : '';
    return '<div class="yz-line">' + img +
      '<div><div class="yz-line__t">' + esc(i.product_title) + '</div>' + v +
      '<div class="yz-line__q"><button type="button" aria-label="' + esc(T('minus')) + '" data-yz-q="' + esc(i.key) + '" data-yz-n="' + (i.quantity - 1) + '">−</button><span>' + i.quantity + '</span><button type="button" aria-label="' + esc(T('plus')) + '" data-yz-q="' + esc(i.key) + '" data-yz-n="' + (i.quantity + 1) + '">+</button></div></div>' +
      '<div class="yz-line__p">' + money(i.original_line_price) + '<button type="button" class="yz-line__rm" data-yz-q="' + esc(i.key) + '" data-yz-n="0">' + esc(T('remove')) + '</button></div></div>';
  }
  function render(cart) {
    var p = cart ? Promise.resolve(cart) : getCart();
    return p.then(function (c) {
      if (dr) {
        var b = dr.querySelector('[data-yz-cart-body]');
        if (b) {
          b.innerHTML = c.item_count
            ? c.items.map(line).join('') + upsell(c)
            : '<div class="yz-empty"><p>' + esc(T('empty')) + '</p><a class="yz-btn" href="' + esc(Y.productUrl || '/') + '">' + esc(T('see')) + '</a></div>';
        }
        var foot = dr.querySelector('.yz-drawer__foot');
        var tot = dr.querySelector('.yz-drawer__total');
        var disc = dr.querySelector('[data-yz-disc]');
        if (!disc && foot && tot) {
          disc = document.createElement('div');
          disc.className = 'yz-drawer__disc';
          disc.setAttribute('data-yz-disc', '');
          foot.insertBefore(disc, tot);
        }
        var saved = (c.original_total_price || c.total_price) - c.total_price;
        if (disc) {
          disc.hidden = saved <= 0;
          disc.innerHTML = '<span>' + esc(T('disc')) + '</span><span>-' + money(saved) + '</span>';
        }
        var t = dr.querySelector('[data-yz-cart-total]');
        if (t) t.textContent = money(c.total_price);
        if (foot) foot.hidden = !c.item_count;
      }
      setCount(c.item_count);
      return c;
    });
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-yz-cart-open]');
    if (o && dr) { e.preventDefault(); render().then(openD); return; }
    if (e.target.closest('[data-yz-cart-close]')) { closeD(); return; }
    var q = e.target.closest('[data-yz-q]');
    if (q) {
      q.disabled = true;
      post(R.cart_change, { id: q.getAttribute('data-yz-q'), quantity: parseInt(q.getAttribute('data-yz-n'), 10) }).then(render).catch(function () { render(); });
      return;
    }
    var a = e.target.closest('[data-yz-addv]');
    if (a) {
      a.disabled = true;
      a.textContent = T('wait');
      post(R.cart_add, { items: [{ id: parseInt(a.getAttribute('data-yz-addv'), 10), quantity: parseInt(a.getAttribute('data-yz-addq'), 10) || 1 }] })
        .then(function () { return render(); })
        .then(bump)
        .catch(function () { render(); });
    }
  });
  if (dr) {
    dr.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });
  }

  /* Ajout au panier sans recharger */
  document.querySelectorAll('form[data-yz-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.fetch || !dr) return;
      e.preventDefault();
      var btn = f.querySelector('[type=submit]');
      var err = f.querySelector('[data-yz-err]');
      var old = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = T('adding');
      if (err) err.textContent = '';
      var req;
      if (f.hasAttribute('data-yz-multi')) {
        var items = itemsFromForm(f);
        if (!items.length) { btn.innerHTML = old; btn.disabled = false; if (err) err.textContent = T('pick'); return; }
        req = post(R.cart_add, { items: items });
      } else {
        req = fetch(R.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) }).then(json);
      }
      req
        .then(function () { btn.textContent = T('added'); bump(); return render(); })
        .then(function () { openD(); setTimeout(function () { btn.innerHTML = old; btn.disabled = false; }, 1200); })
        .catch(function (j) { btn.innerHTML = old; btn.disabled = false; if (err) err.textContent = (j && j.description) || T('oops'); });
    });
  });

  /* Barre d'achat collante */
  var st = document.querySelector('[data-yz-sticky]');
  var buy = document.querySelector('[data-yz-buy]');
  if (st && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { st.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0); });
    }).observe(buy);
    var sb = st.querySelector('[data-yz-sticky-btn]');
    if (sb) sb.addEventListener('click', function () {
      var f = buy.querySelector('form');
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type=submit]').click();
    });
    var pr = st.querySelector('[data-yz-sticky-price]');
    var nm = st.querySelector('[data-yz-sticky-name]');
    function syncSticky() {
      var r = buy.querySelector('input[name=yz_pack]:checked') || buy.querySelector('input[name=id]:checked');
      if (!r) return;
      if (pr && r.getAttribute('data-price')) pr.textContent = r.getAttribute('data-price');
      if (nm && r.getAttribute('data-name')) nm.textContent = r.getAttribute('data-name');
    }
    syncSticky();
    buy.addEventListener('change', function (e) {
      if (e.target.name === 'yz_pack' || e.target.name === 'id') syncSticky();
    });
  }
})();
